// Nhãn tiếng Việt đời thường + so sánh cũ/mới của cấu hình Xu (hàm THUẦN, không đụng React).
// Dùng cho Modal "Bạn đang đổi…" trước khi lưu và cảnh báo số thưởng tăng > 2 lần.
import { MISSION_LABELS } from "./xu-format-helpers";

const isObj = (v) => v && typeof v === "object" && !Array.isArray(v);

const PERK = { withdraw: "Quyền rút tiền", voucher: "Voucher", support: "Hỗ trợ" };
const TIER_FIELD = { name: "tên", min: "ngưỡng điểm (đ)", mult: "hệ số Xu", perks: "quyền lợi" };
const MISSION_FIELD = { reward: "thưởng", seconds: "số giây xem", goldenHours: "giờ vàng", maxOrderAgeHours: "đơn không cũ quá (giờ)", title: "tên", description: "mô tả", icon: "biểu tượng", screen: "màn hình", enabled: "bật/tắt", order: "thứ tự" };
let missionTitles = {}; // key → tên NV, cập nhật mỗi lần diffConfig/bigIncreases để nhãn hiện tên thay vì mã
const SIMPLE = {
    dailyCap: "Trần Xu mỗi người mỗi ngày",
    xuTtlDays: "Hạn dùng của Xu (ngày)",
    allMissionsBonus: "Thưởng khi làm đủ 3 nhiệm vụ",
    rankLaunchAt: "Ngày ra mắt hạng",
    rankChannels: "Kênh đơn tính điểm hạng",
    newUserLockDays: "Số ngày giữ thưởng lớn của tài khoản mới",
    budgetDaily: "Ngân sách Xu mỗi ngày",
    budgetMonthly: "Ngân sách Xu mỗi tháng",
    "reminder.hour": "Giờ nhắc điểm danh",
    "reminder.minStreak": "Chỉ nhắc khi chuỗi từ (ngày)",
};

/** Đường dẫn khoá (vd "checkinRewards.6") → nhãn tiếng Việt. */
export function labelOf(path) {
    if (SIMPLE[path]) return SIMPLE[path];
    let m = /^checkinRewards\.(\d+)$/.exec(path);
    if (m) return `Thưởng điểm danh ngày ${Number(m[1]) + 1}`;
    m = /^milestones\.(\d+)\.(\w+)$/.exec(path);
    if (m) return `Mốc chuỗi thứ ${Number(m[1]) + 1} — ${m[2] === "day" ? "số ngày" : m[2] === "xu" ? "thưởng" : m[2]}`;
    m = /^missions\.(\w+)\.(\w+)/.exec(path);
    if (m) return `Nhiệm vụ "${missionTitles[m[1]] || MISSION_LABELS[m[1]] || m[1]}" — ${MISSION_FIELD[m[2]] || m[2]}`;
    m = /^rankTiers\.(\d+)\.(\w+)(?:\.(\w+))?$/.exec(path);
    if (m) return `Hạng ${Number(m[1]) + 1} — ${TIER_FIELD[m[2]] || m[2]}${m[3] ? ` (${PERK[m[3]] || m[3]})` : ""}`;
    m = /^rulesPages\.(\w+)$/.exec(path);
    if (m) return `Trang quy định (${{ checkin: "điểm danh", missions: "nhiệm vụ", rank: "hạng", general: "chung" }[m[1]] || m[1]})`;
    m = /^missionTexts\.(\w+)$/.exec(path);
    if (m) return `Mô tả nhiệm vụ "${MISSION_LABELS[m[1]] || m[1]}"`;
    return path;
}

/** Trải phẳng object thành { "a.b.0": giá trị lá }; mảng toàn số/chuỗi coi là 1 lá. */
function flatten(value, prefix = "", out = {}) {
    const primitiveArray = Array.isArray(value) && value.every((x) => !x || typeof x !== "object");
    if (isObj(value) || (Array.isArray(value) && !primitiveArray)) {
        Object.entries(value).forEach(([k, v]) => flatten(v, prefix ? `${prefix}.${k}` : k, out));
    } else {
        out[prefix] = value;
    }
    return out;
}

function show(path, v) {
    if (typeof v === "boolean") return v ? "Bật" : "Tắt";
    if (v === null || v === undefined || v === "") return "(trống)";
    if (path === "rankLaunchAt") {
        const d = new Date((Number(v) + 7 * 3600) * 1000);
        const p = (n) => String(n).padStart(2, "0");
        return `${p(d.getUTCDate())}/${p(d.getUTCMonth() + 1)}/${d.getUTCFullYear()} ${p(d.getUTCHours())}:${p(d.getUTCMinutes())}`;
    }
    if (Array.isArray(v)) return v.length ? v.join(", ") : "(trống)";
    return String(v);
}

/** Danh sách thay đổi cũ → mới, đã có nhãn tiếng Việt. */
export function diffConfig(before, after) {
    setTitles(before, after);
    const a = flatten(before);
    const b = flatten(after);
    const added = Object.keys(after.missions || {}).filter((k) => !before.missions?.[k]);
    const isNew = (p) => added.some((k) => p.startsWith(`missions.${k}.`));
    const rows = [...new Set([...Object.keys(a), ...Object.keys(b)])]
        .filter((p) => !isNew(p) && JSON.stringify(a[p] ?? null) !== JSON.stringify(b[p] ?? null))
        .map((p) => ({ path: p, label: labelOf(p), from: show(p, a[p]), to: show(p, b[p]) }));
    // NV mới thêm: gom thành 1 dòng thay vì mỗi trường 1 dòng.
    const addRows = added.map((k) => ({ path: `missions.${k}`, label: "Thêm nhiệm vụ mới", from: "(chưa có)", to: `“${after.missions[k].title}” +${after.missions[k].reward} Xu` }));
    return [...rows, ...addRows];
}

function setTitles(before, after) {
    missionTitles = Object.fromEntries(Object.entries({ ...(before.missions || {}), ...(after.missions || {}) }).map(([k, m]) => [k, m.title]));
}

const isRewardPath = (p) =>
    /^checkinRewards\.\d+$/.test(p) || /^milestones\.\d+\.xu$/.test(p) || /^missions\.\w+\.reward$/.test(p) || p === "allMissionsBonus";

/** Số thưởng tăng hơn 2 lần so với số cũ (số cũ > 0). */
export function bigIncreases(before, after) {
    setTitles(before, after);
    const a = flatten(before);
    const b = flatten(after);
    return Object.keys(b)
        .filter((p) => isRewardPath(p) && Number(a[p]) > 0 && Number(b[p]) > Number(a[p]) * 2)
        .map((p) => `${labelOf(p)}: ${a[p]} → ${b[p]} Xu (hơn 2 lần)`);
}

/** Xu thực nhận = gốc × hệ số, làm tròn xuống (khớp computeGrant ở backend, nhân số nguyên ×100). */
export const applyMult = (base, mult) => Math.floor((Number(base || 0) * Math.round(Math.max(1, Number(mult) || 1) * 100)) / 100);
